import { render, staticRenderFns } from "./trafficIndex.vue?vue&type=template&id=dc7c4e00&scoped=true"
import script from "./trafficIndex.vue?vue&type=script&lang=js"
export * from "./trafficIndex.vue?vue&type=script&lang=js"
import style0 from "./trafficIndex.vue?vue&type=style&index=0&id=dc7c4e00&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc7c4e00",
  null
  
)

export default component.exports